import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CallingIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.65741 2.00039C7.77441 2.01539 8.57041 2.85239 9.57741 3.91139C9.82641 4.17239 10.0954 4.45739 10.3964 4.75739C11.8554 6.21739 11.4404 7.40839 11.1054 8.36439C10.7414 9.40739 10.4264 10.3074 12.3124 12.1934C14.1984 14.0794 15.0974 13.7644 16.1394 13.3974C17.0964 13.0634 18.2844 12.6454 19.7464 14.1054C20.0434 14.4024 20.3234 14.6684 20.5834 14.9154C21.6464 15.9274 22.4864 16.7264 22.5006 17.8464C22.5114 18.8004 21.9314 19.7744 20.4994 21.2064L19.8654 20.7764L20.4024 21.2994C20.0854 21.6244 19.2424 22.4904 17.5914 22.5004H17.5614C15.0694 22.5004 11.8204 20.5164 7.90441 16.6014C3.97241 12.6704 1.98541 9.41139 2.00033 6.91439C2.00941 5.26439 2.87441 4.41939 3.19941 4.10239L3.22715 4.07209L3.29441 4.00439C4.72941 2.56939 5.71541 1.97939 6.65741 2.00039ZM6.63841 3.50039H6.63041C6.18135 3.50039 5.49938 3.95039 4.54824 4.87428L4.35724 5.06185L4.35941 5.06139C4.35941 5.06139 4.34309 5.08011 4.31528 5.10848L4.24841 5.17539C4.00641 5.41039 3.50541 5.89939 3.50036 6.92239C3.49241 8.35339 4.43341 11.0104 8.96441 15.5404C13.4734 20.0484 16.1264 21.0004 17.5614 21.0004H17.5824C18.6054 20.9944 19.0934 20.4934 19.3284 20.2524C19.3994 20.1794 19.4574 20.1244 19.4984 20.0914C20.4954 19.0884 21.0054 18.3434 21.0004 17.8644C20.9944 17.3764 20.3874 16.8004 19.5484 16.0014C19.2814 15.7484 18.9914 15.4714 18.6854 15.1654C17.8914 14.3744 17.5004 14.5094 16.6354 14.8134C15.4404 15.2324 13.8034 15.8064 11.2524 13.2534C8.70041 10.7024 9.27241 9.06539 9.68941 7.86939C9.99141 7.00539 10.1294 6.61239 9.33641 5.81839C9.02641 5.50839 8.74741 5.21439 8.49041 4.94439C7.69641 4.11039 7.12341 3.50739 6.63841 3.50039ZM15.2465 5.55789C17.3275 5.96189 18.9345 7.56789 19.3395 9.64989C19.4185 10.0579 19.1535 10.4509 18.7475 10.5299C18.6985 10.5389 18.6505 10.5439 18.6025 10.5439C18.2505 10.5439 17.9375 10.2959 17.8675 9.93789C17.5795 8.45789 16.4385 7.31689 14.9605 7.02989C14.5535 6.95089 14.2885 6.55789 14.3675 6.15089C14.4465 5.74389 14.8465 5.47789 15.2465 5.55789ZM15.1866 2.00609C19.2646 2.45909 22.4316 5.62209 22.8886 9.69909C22.9346 10.1111 22.6386 10.4821 22.2276 10.5281C22.1996 10.5311 22.1706 10.5331 22.1426 10.5331C21.7656 10.5331 21.4416 10.2501 21.3986 9.86709C21.0196 6.49109 18.3976 3.87109 15.0206 3.49609C14.6096 3.45009 14.3126 3.08009 14.3586 2.66809C14.4036 2.25709 14.7706 1.95409 15.1866 2.00609Z",
      fill: __props.color || '#ADB5BD'
    }, null, 8, _hoisted_2)
  ]))
}
}

})